/* 分开之后得改路由，写全名，要不报错 */
import {
	formatDate
}
from '../common/filters.js'
import {
	isvalidOption,
	isvalidBatchOption,
}
	from '../common/validate.js'
import store from '@/store/store'
	
export default {
	name: '/manage/main.exam_question',
	filters: {
		formatDate(time) {
			var date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd')
		}
	},
	data() {
		var validatePassStem = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请录入试题题干'))
			} else {
				callback()
			}
		}
		var validatePassOption = (rule, value, callback) => {
			if (this.form.questionType == 1 || this.form.questionType == 4) {
				if (!value) {
					return callback(new Error('请录入选项'))
				} else {
					callback()
				}
			} else {
				callback()
			}
		}
		var validatePassAnswer = (rule, value, callback) => {
			if (!value) {
				return callback(new Error('请录入正确答案'))
			}
			if (this.form.questionType == 1) {
				if (!isvalidOption(value)) {
					callback(new Error('只可填写其中1个选项,如:B'))
				} else {
					callback()
				}
			} else if (this.form.questionType == 4) {
				if (!isvalidBatchOption(value)) {
					callback(new Error('请按顺序填写格式,如:ABD'))
				} else if (value.length < 2) {
					callback(new Error('至少录入两个选项'))
				} else {
					callback()
				}
			} else {
				callback()
			}
		}
		var validatePassFraction = (rule, value, callback) => {
			// console.log(value) 
			if (!value) {
				return callback(new Error('请录入分数'))
			} else {
				callback()
			}
			/* setTimeout(() => {
			  if (!Number.isInteger(value)) {
			    console.log(Number.isInteger(value))
			    callback(new Error('必须是数字')) 
			  }
			  else if (value <= 0) {
			    callback(new Error('分数不能小于1')) 
			  } else {
			    callback() 
			  }
			})  */
		}
		return {
			staffId: store.getters.staffId,
			/* 主页面表格试题参数 */
			question: {
				id: '',
				stem: '',
				questionType: '',
				questionClass: [],
				createTime: '',
				sidno: '',
				size: 10,
				pageNum: 1,
				total: 0,
				rows: []
			},
			multipleSelection: [],

			auditShow: false,

			show: false,
			radioShow: false,
			checkShow: false,
			judgeShow: false,
			packShow: false,
			checkAnswer: [],

			sysUser: {},
			addDialogFormVisible: false,
			updateDialogFormVisible: false,
			/* 添加、修改等试题参数 */
			form: {
				isExamManager: store.getters.isExamManager,
				gardenId: store.getters.gardenId,
				stem: '',
				answer: '',
				questionType: '',
				questionClass: '',
				questionFraction: '',
				topicMaker: '',
				operPeople: '',
				state: 1,
				isCheck: 1,
				/* 试题内的选项 */
				option: [{
					optionNum: '',
					content: ''
				}]
			},
			additemForm: {},
			formLabelWidth: '150px',

			/* 上传页面 */
			uploadDialogVisible: false,
			fileList: [],

			/* 修改出题人 */
			staffName: [],
			state: '',
			timeout: null,

			/* 审核 */
			reviewDialogFormVisible: false,
			reviewMultipleSelection: [],
			reviewTable: {
				stem: '',
				sidno: '',
				pageNum: 1,
				size: 10,
				total: 0,
				rows: []
			},

			/* 主页面加载 */
			loading: true,
			// updateLoading: true,

			/* maintaintype列表 */
			maintaintype: [],
			typeProps: {
				value: 'Id',
				label: 'Name',
				children: 'children',
				checkStrictly: true
			},
			/* 删除提醒变量 */
			paperList: '',

			/* 表单验证 */
			rules: {
				stem: [{
					required: true,
					trigger: 'blur',
					validator: validatePassStem
				}],
				/* option: [{required: true,trigger: 'blur',validator: validatePassOption}], */
				answer: [{
					required: true,
					trigger: 'blur',
					validator: validatePassAnswer
				}],
				questionFraction: [{
					required: true,
					/* trigger: 'blur',
					message: '请选择题目分', */
					trigger: 'blur',
					validator: validatePassFraction
				}],
				questionType: [{
					required: true,
					message: '请选择题型',
					trigger: 'change'
				}],
				questionClass: [{
					required: true,
					type: 'string',
					message: '请选择类型',
					trigger: 'change',
					transform(value) {
						var base
						if (value) {
							// 在select中转换要加这个判断,因为select默认有一个空选项
							base = '' + value
						}
						return base
					}
				}]
			},
			rulesOptions: [{
				required: true,
				validator: validatePassOption,
				trigger: 'blur'
			}]

		}
	},
	methods: {
		/* fenye: function(pageNum) {let size = this.sizevar param = {stem: this.stem,questionType: this.questionType,questionClass: this.questionClass,sidno: this.sidno,state: 1} this.$fenye('zhongljBack/mapi/Exam_Question/selectcount', 'zhongljBack/mapi/Exam_Question/selectAllNotOption',param,pageNum, size, result => {this.question = result // console.log(this.question.questionClass)this.pageNum = result.pageNum })} */

		/* 试题主页查询 */
		selectList() {
			// var params = new URLSearchParams()
			var type = ''
			if (this.question.questionClass != '' && this.question.questionClass != null && this.question.questionClass !=
				undefined) {
				type = this.question.questionClass[this.question.questionClass.length - 1]
			}

			// params.append('stem', this.question.stem)
			// params.append('questionType', this.question.questionType)
			// params.append('questionClass', type)
			// params.append('sidno', this.question.sidno)
			// params.append('pageNo', this.question.pageNum)
			// params.append('pageSize', this.question.size)
			// params.append('state', 1)
			// params.append('isCheck', 1) /* 先不上审核 */
			
			let params = {
				'stem': this.question.stem,
				'questionType': this.question.questionType,
				'questionClass': type,
				'sidno': this.question.sidno,
				'pageNo': this.question.pageNum,
				'pageSize': this.question.size,
				'state': 1,
				'isCheck': 1,
				'gardenId': store.getters.gardenId,
				'type': 1
			}

			this.$post('Exam_Question/selectAllNotOption', params)
				.then(response => {
					this.question.rows = response.list.rows
					this.question.total = response.total
					this.question.pageNum = response.list.page

					this.loading = false
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		/* 分页组件当前页 */
		handleCurrentChange(val) {
			this.selectList()
		},
		/* 分页组件 每页长度 */
		handleSizeChange(val) {
			this.question.size = val
			// console.log(val)
			this.selectList()
		},
		/* 多选 */
		handleSelectionChange(val) {
			this.multipleSelection = val
			// console.log(this.multipleSelection)
		},
		/* 批量删除试题 */
		delBatch() {
			this.$confirm('即将删除已选试题, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const quesArr = []
				for (var i = 0; i < this.multipleSelection.length; i++) {
					quesArr[i] = this.multipleSelection[i].id
				}
				// console.log(quesArr)
				this.$post('Exam_Question/delBatch', {
						idArr: quesArr
					})
					.then(response => {
						this.selectList()
						this.$message({
							type: 'success',
							message: '删除成功!'
						})
					})
					.catch(error => {
						console.log(error)
						this.$message.error(error)
					})
				/* this.$notify({title: '提示',message: '删除成功!',type: 'success',position: 'bottom-right'})  */
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				})
				/* this.$notify({title: '提示',message: '已取消删除',type: 'success',position: 'bottom-right'})  */
			})
		},
		del(row) {
			/* 取得所有包含该试题的试卷名 */
			var paperList = ''
			this.$postJson('Exam_Paper_Question/selectPaperName', {
					questionId: row.id
				})
				.then(response => {
					// console.log(response.list)
					for (let i = 0; i < response.list.length; i++) {
						if (i == 0) {
							paperList += response.list[i].paperName
						} else {
							paperList += '，' + response.list[i].paperName
						}
					}

					/* 判断如果paperList为null，删除。不为null，提示 */
					if (paperList == '') {
						this.$confirm('是否删除该试题?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$postJson('Exam_Question/update', {
									id: row.id,
									questionType: row.questionType,
									state: 0
								})
								.then(response => {
									this.selectList()
									this.$message({
										type: 'success',
										message: '删除成功!'
									})
								})
								.catch(error => {
									console.log(error)
									this.$message.error(error)
								})
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							})
						})
					} else {
						this.$alert('<strong>以下试卷包含该试题，请先在试卷内移除该题目</strong><br >' + paperList, '提示', {
							dangerouslyUseHTMLString: true,
							confirmButtonText: '知道了',
							center: true
						}).catch(() => {})
					}
					// console.log(paperList)
				})
				.catch(error => {
					this.$message.error(error)
					console.log(error)
				})
		},
		clear() {
			this.question.stem = ''
			this.question.questionType = ''
			this.question.questionClass = ''
			this.question.sidno = ''
		},
		select() {
			this.question.pageNum = 1
			this.selectList()
		},

		/* 添加试题时更改题型是否隐藏选项 */
		addIsShow() {
			let value = this.form.questionType
			if (value == 1 || value == 4) {
				this.show = 1
			} else {
				this.show = 0
			}
			if (value == 1) {
				this.radioShow = 1
				this.judgeShow = 0
				this.packShow = 0
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 2) {
				this.radioShow = 0
				this.judgeShow = 1
				this.packShow = 0
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 3) {
				this.radioShow = 0
				this.judgeShow = 0
				this.packShow = 1
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 4) {
				this.radioShow = 0
				this.judgeShow = 0
				this.packShow = 0
				this.checkShow = 1
				this.form.answer = ''
			}
		},
		add() {
			this.addDialogFormVisible = true
			this.form.stem = ''
			this.form.answer = ''
			this.checkAnswer = []
			this.form.questionFraction = ''
			this.form.questionClass = ''
			this.state = ''
			this.form.topicMaker = ''
			this.form.option = [{
					optionNum: 'A'
				},
				{
					optionNum: 'B'
				}
			]
			/* this.form.questionType = '' this.form.questionClass = '' this.show = 0  */
		},
		/* 新增选项 */
		addOption() {
			this.form.option.push({
				optionNum: '',
				content: ''
			})
		},
		/* 移除选项 */
		removeOption(item) {
			var index = this.form.option.indexOf(item)
			if (index > 1) {
				this.form.option.splice(index, 1)
			}
			/* 循环多选时保存的答案数组 */
			for (let i = 0; i < this.checkAnswer.length; i++) {
				/* 如果里面的某一个元素和要删除的选项是一样的  多选数组就移除这个元素 */
				if (this.checkAnswer[i] == String.fromCharCode(65 + index)) {
					this.checkAnswer.splice(i, 1)
				}
			}
			/* 单选题必须清空答案 */
			if (this.form.questionType == 1) {
				this.form.answer = ''
			}
			// console.log(this.checkAnswer)
		},
		addQues(form) {
			// console.log(this.form.questionFraction) 
			/* 2020年6月8日：分类转换 */
			if (this.form.questionClass != '' && this.form.questionClass != null && this.form.questionClass != undefined) {
				form.questionClass = this.form.questionClass[this.form.questionClass.length - 1]
			}
			/* 循环选项、保存值（ABEDEFG...） */
			for (var i = 2; i < form.option.length; i++) {
				if (form.option[i].content != null || form.option[i].content != '' || form.option[i].content !=
					undefined) {
					form.option[i].optionNum = String.fromCharCode(65 + i)
				}
			}
			// console.log(form.option[4].optionNum)

			/* 正确答案排序 */
			if (form.questionType == 4) {
				var arr = []
				
				/* 循环数组转换成Unicode */
				for (let j = 0; j < this.checkAnswer.length; j++) {
					var a = this.checkAnswer[j]
					arr.push(a.charCodeAt())
				}
				var arrSort = arr.sort() /* 进行排序 */
				this.checkAnswer = [] /* 清空数组 */
				for (let j = 0; j < arrSort.length; j++) {
					var s = String.fromCharCode(arrSort[j]) /* 每个Unicode转换成字符串 */
					// console.log(s)
					this.checkAnswer.push(s) /* 添加进数组 */
				}
				// console.log(this.checkAnswer.join(""))
				form.answer = this.checkAnswer.join('') /* 数组中每个元素分隔，如果不写引号默认逗号分隔 */
			}
			// console.log(this.form.answer)

			/* 添加试题请求 */
			this.$refs.form.validate((valid) => {
				if (valid) {
					let loading = this.$loading()
					/* if (form.questionType == 1 || form.questionType == 4) {
					  form.answer = form.answer.toUpperCase() 
					} */
					if (this.state == '' || this.state == null || this.state == undefined) {
						form.topicMaker = this.staffId
					}
					form.operPeople = this.staffId

					this.$get(`/groupsByGardenId/` + this.form.gardenId).then(
						res => {
							if (res.list.length > 0) {
								this.$postJson('Exam_Question/add', form)
								.then(response => {
									loading.close()
									this.addDialogFormVisible = false
									this.selectList()
									this.$message({
										type: 'success',
										message: '提交成功!'
									})
								})
								.catch(error => {
									this.$message.error(error)
									console.log(error)
								})
							} else {
								loading.close()
								this.$message.error(this.$i18n.t('此小区未设置集团，请先设置集团。'))
							}
						},
						err => {
							loading.close()
							this.$message.error(err)
						})				
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},

		/* 修改模块 */
		updateIsShow() {
			let value = this.form.questionType
			if (value == 1 || value == 4) {
				this.show = 1
				// console.log(this.show)
			} else {
				this.show = 0
			}
			if (value == 1) {
				this.radioShow = 1
				this.judgeShow = 0
				this.packShow = 0
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 2) {
				this.radioShow = 0
				this.judgeShow = 1
				this.packShow = 0
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 3) {
				this.radioShow = 0
				this.judgeShow = 0
				this.packShow = 1
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 4) {
				this.radioShow = 0
				this.judgeShow = 0
				this.packShow = 0
				this.checkShow = 1
				this.form.answer = ''
			}
		},
		update(row) {
			this.updateDialogFormVisible = true
			let value = row.questionType
			var option = [{
					optionNum: 'A'
				},
				{
					optionNum: 'B'
				}
			]
			if (value == 1 || value == 4) {
				this.show = 1
			} else {
				this.show = 0
			}
			if (value == 1) {
				this.radioShow = 1
				this.judgeShow = 0
				this.packShow = 0
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 2) {
				this.radioShow = 0
				this.judgeShow = 1
				this.packShow = 0
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 3) {
				this.radioShow = 0
				this.judgeShow = 0
				this.packShow = 1
				this.checkShow = 0
				this.form.answer = ''
			} else if (value == 4) {
				this.radioShow = 0
				this.judgeShow = 0
				this.packShow = 0
				this.checkShow = 1
				this.form.answer = ''
			}
			this.form = {}
			this.state = ''
			// console.log(row)
			let loading = this.$loading()
			this.$postJson(`/Exam_Question/selectall`, {
					'id': row.id
				})
				.then(res => {
					loading.close()
					this.form = res.key[0]
					if (this.form.option.length == 0) {
						this.form.option = option
					}
					// 更改试题回显多选答案
					if (value == 4) {
						var str = this.form.answer // 获取字符串答案
						this.checkAnswer = str.split('') // 截取字符串切割成一个数组
					}
				})
				.catch(err => {
					loading.close()
					this.$message.error(err)
				})
			/* this.$post(`Exam_Question/selectall`, {
					'id': row.id
				})
				.then(response => {
					console.log(response.key[0]) 
					this.form = response.key[0]
					if (this.form.option.length == 0) {
						this.form.option = option
					}
					// 更改试题回显多选答案
					if (value == 4) {
						var str = this.form.answer // 获取字符串答案
						this.checkAnswer = str.split('') // 截取字符串切割成一个数组
					}
					// this.updateLoading=false 
					// console.log(str.split(""))
				}).catch(error => {
					console.log(error)
				}) */
		},
		updateQues(form) {
			let loading = this.$loading()
			/* 2020年6月8日：分类转换 */
			/* Array.isArray(数组名) 判断是否为数组 返回boolean */
			if (Array.isArray(form.questionClass)) {
				form.questionClass = form.questionClass[form.questionClass.length - 1]
			}
			/* 循环选项、保存值（ABEDEFG...） */
			for (var i = 2; i < form.option.length; i++) {
				if (form.option[i].content != null || form.option[i].content != '' || form.option[i].content !=
					undefined) {
					form.option[i].optionNum = String.fromCharCode(65 + i)
				}
			}
			if (form.questionType == 4) {
				var arr = [] /* 循环数组转换成Unicode */
				
				for (let j = 0; j < this.checkAnswer.length; j++) {
					var a = this.checkAnswer[j]
					arr.push(a.charCodeAt())
				}
				var arrSort = arr.sort() /* 进行排序 */
				this.checkAnswer = [] /* 清空数组 */
				for (let j = 0; j < arrSort.length; j++) {
					var s = String.fromCharCode(arrSort[j]) /* 每个Unicode转换成字符串 */
					// console.log(s)
					this.checkAnswer.push(s) /* 添加进数组 */
				}
				// console.log(this.checkAnswer.join(""))
				form.answer = this.checkAnswer.join('') /* 数组中每个元素分隔，如果不写引号默认逗号分隔 */
			}
			this.$refs.form.validate((valid) => {
				if (valid) {
					// console.log(form.answer) 
					/* if (form.questionType == 1 || form.questionType == 4) {// console.log(form.answer)form.answer = form.answer.toUpperCase() } */
					/* if (this.state!==''||this.state!==null||this.state!==undefined) {
					  form.topicMaker = this.$route.query.userid 
					} */
					form.operPeople = this.staffId
					this.$postJson('Exam_Question/update', form)
						.then(response => {
							this.updateDialogFormVisible = false
							this.reviewDialogFormVisible = false
							this.selectList()
							this.$message({
								type: 'success',
								message: '修改成功!'
							})
							loading.close()
						}).catch(error => {
							console.log(error)
							this.$message.error(error)
							loading.close()
						})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},

		/* 更改出题人逻辑 */
		loadAll() {
			this.$post('Exam_Staff/updateTopicMaker')
				.then(response => {
					// console.log(response.list)
					/*
					for(let i=0 i<response.list.length i++){
					   this.staffName.push({'value':response.list[i].idNo})
					} */
					this.staffName = response.list
				})
				.catch(error => {
					console.log(error)
					this.$message.error(error)
				})
		},
		querySearchAsync(queryString, cb) {
			var staffName = this.staffName
			var results = queryString ? staffName.filter(this.createStateFilter(queryString)) : staffName
			// console.log(results)
			clearTimeout(this.timeout)
			this.timeout = setTimeout(() => {
				cb(results)
			}, 1000 * Math.random())
		},
		createStateFilter(queryString) {
			return (state) => {
				// console.log(state)
				return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
			}
		},
		handleSelect(item) {
			// console.log(item.id) 
			this.form.topicMaker = item.id
		},

		/* 上传模块 */
		upload() {
			this.uploadDialogVisible = true
		},
		handleRemove(file, fileList) {
			// console.log(file, fileList) 
		},
		handlePreview(file) {
			// console.log(file) 
		},
		handleExceed(files, fileList) {
			this.$message.warning(`请刷新页面再次上传`)
		},
		beforeRemove(file, fileList) {
			// return this.$confirm(`确定移除 ${ file.name }？`) 
		},
		beforeUpload(file) {
			var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
			const extension = testmsg === 'xls'
			// const extension2 = testmsg === 'xlsx'
			/* 限制文件大小 */
			const isLt2M = file.size / 1024 / 1024 < 2
			if (!extension /* && !extension2 */) {
				this.$message.error('文件格式错误，请上传xls后缀文件')
				return false
			}
			if (!isLt2M) {
				this.$message.error('上传文件大小不能超过 2MB!')
			}
			// return isJPG && isLt2M 
			// return (extension || extension2) && isLt2M
			return extension && isLt2M
		},
		uploadExcel(file) {
			this.loading = true 
			let params = new FormData()
			params.append('file', file.file)
			params.append('gardenId', this.form.gardenId)
			this.$postFormData(`/Exam_Question/inputQuestion`, params)
			.then(response => {
					this.loading = false
					if (response.errCode == 0) {
						this.$message.success('导入成功')
						this.uploadDialogVisible = false
					}
					if (response.errCode == 4) {
						this.$message.error('导入失败')
					}
					// console.log(response)
				})
				.catch(error => {
					this.loading = false
					console.log(error)
					this.$message.error(error)
				})
		},

		/* 审核模块 */
		reviewHandleCurrentChange() {
			this.review()
		},
		reviewHandleSizeChange(val) {
			this.reviewTable.size = val
			this.review()
		},
		reviewHandleSelectionChange(val) {
			this.reviewMultipleSelection = val
			// console.log(val)
		},
		review() {
			this.reviewDialogFormVisible = true
			// var params = new URLSearchParams()
			// params.append('sidno', this.reviewTable.sidno)
			// params.append('pageNo', this.reviewTable.pageNum)
			// params.append('pageSize', this.reviewTable.size)
			// params.append('state', 1)
			// params.append('isCheck', 0)
			let params = {
				'sidno': this.reviewTable.sidno,
				'pageNo': this.reviewTable.pageNum,
				'pageSize': this.reviewTable.size,
				'state': 1,
				'isCheck': 0
			}

			this.$post('Exam_Question/selectAllNotOption', params)
				.then(response => {
					// console.log(response.list.rows)
					this.reviewTable.rows = response.list.rows
					this.reviewTable.total = response.total
					this.reviewTable.pageNum = response.list.page
				})
				.catch(error => {
					console.log(error)
					this.$message.error(error)
				})
		},
		reviewQues() {
			const quesArr = []
			for (let i = 0; i < this.reviewMultipleSelection.length; i++) {
				quesArr[i] = this.reviewMultipleSelection[i].id
			}
			this.$postJson('Exam_Question/reviewBatch', {
					isCheck: 1,
					idArr: quesArr
				})
				.then(response => {
					this.reviewDialogFormVisible = false
					this.$message({
						type: 'success',
						message: '审核成功!'
					})
				})
				.catch(error => {
					console.log(error)
					this.$message.error(error)
				})
		},
		// 模板下载
		downLoad() {
			window.open('https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/web/exam.xls')
		},
	},
	beforeMount: function () {
		// this.sysUser = this.$getSessionStorage('staff') 
	},
	mounted() {
		this.selectList()
		/* 查询类型列表 */
		this.$get(`Exam_Type/selectAllList?gardenId=${this.$store.getters.gardenId}`)
			.then(response => {
				var typeList = response.list
				/* 2020年6月8日：递归、将children.length=0 的赋值 null */
				for (let i = 0; i < typeList.length; i++) {
					/* 2020年6月8日：三层分类的话必须先将第三层赋值为null。 */
					if (typeList[i].children.length != 0) {
						for (let j = 0; j < typeList[i].children.length; j++) {
							if (typeList[i].children[j].children < 1) {
								typeList[i].children[j].children = undefined
							}
						}
					} else {
						typeList[i].children = null
					}
					// console.log(typeList[i].children) 
				}
				this.maintaintype = typeList
				// console.log(this.maintaintype) 
			})
			.catch(error => {
				console.log(error)
				this.$message.error(error)
			})

		/* 获取用户权限 */
		var params = new URLSearchParams()
		params.append('staffId', this.staffId)
		this.$post('Exam_Authority/select', params)
			.then(response => {
				// console.log(this.$route.query.userid)
				// console.log(response.list.rows[0].auditAuthority)
				if (response.list.rows[0].auditAuthority == 1) {
					this.auditShow = true
				} else {
					this.auditShow = false
				}
			})
			.catch(error => {
				console.log(error)
				this.$message.error(error)
			})

		/* 查询staff列表（更改出题人） */
		this.loadAll()
	},
	computed: {
		stemPlaceholder() {
			if (this.form.questionType == 3) {
				return '请录入题目' /* "录入题目示例:以_相伴一生" */
			} else if (this.form.questionType == 1 || this.form.questionType == 4) {
				return '请录入题目' /* "录入题目示例:以()相伴一生" */
			}
		}
	}
}
